import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs/Observable'

import { selectDefaultIncidentDateFilter } from 'containers/App/selectors'
import { FETCH_SELECTED_COMPANY_DATA_ASYNC } from 'containers/PartnerOptions/constants'
import { selectCompanyFilter } from 'containers/PartnerOptions/selectors'
import { REGULAR_FILTERS_CHANGE } from 'containers/ResolutionCenter/IncidentFilters/constants'
import { selectRegularFilters } from 'containers/ResolutionCenter/IncidentFilters/selectors'

import {
  incidentsCountPolling,
  incidentsCountPollingError,
  incidentsCountPollingSuccess,
} from './actions'
import { INCIDENTS_COUNT_POLLING_ASYNC, MINIMAL_ALLOWED_POLLING_INTERVAL } from './constants'

/**
 * An example of setInterval on the Epic level.
 * Main benefit of this is that every new request
 * happens only once previous is finished with
 * an ability to define a custom delay.
 */
const incidentsCountPollingEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$
    .ofType(
      INCIDENTS_COUNT_POLLING_ASYNC.INITIATE,
      INCIDENTS_COUNT_POLLING_ASYNC.SUCCESS,
      INCIDENTS_COUNT_POLLING_ASYNC.ERROR,
      FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS,
      REGULAR_FILTERS_CHANGE
    )
    // Stop polling if no permissions.
    // FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS
    // will restart if company has changed.
    .filter((action) =>
      action.type === REGULAR_FILTERS_CHANGE && action.payload.filterType === 'dateFilter'
        ? true
        : action.type !== INCIDENTS_COUNT_POLLING_ASYNC.ERROR && action.error?.status !== 403
    )
    .delay(MINIMAL_ALLOWED_POLLING_INTERVAL)
    .switchMap(() => {
      if (document.visibilityState === 'hidden') {
        return Observable.of(incidentsCountPolling())
      } else {
        const state = store.getState()
        const selectedCompany = selectCompanyFilter(state)?.value
        let dateFilter
        try {
          dateFilter = selectRegularFilters(state).dateFilter
        } catch (e) {
          try {
            dateFilter = selectDefaultIncidentDateFilter(state)
          } catch (err) {
            dateFilter = null
          }
        }
        return api.resolutionCenter
          .fetchIncidentsCount(selectedCompany, dateFilter)
          .map((response) => incidentsCountPollingSuccess(response))
          .catch((error) =>
            Observable.of(epicsErrorHandler(incidentsCountPollingError, error, [403]))
          )
      }
    })

export default combineEpics(incidentsCountPollingEpic)
